import React, { useEffect, useState } from "react";
import { API_URL } from "../../constants/appConfig";
import myToast from "../../components/toast";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  MenuItem,
  Paper,
  Typography,
  Tabs,
  Tab,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";

const CategoryAdd = ({ onClose }) => {
  const [tabValue, setTabValue] = useState(0);
  const [mainCategoryName, setMainCategoryName] = useState("");
  const [mainCategoryDescription, setMainCategoryDescription] = useState("");
  const [selectedCategoryForSub, setSelectedCategoryForSub] = useState(null);
  const [subCategoryNameForSub, setSubCategoryNameForSub] = useState("");
  const [subCategoryDescriptionForSub, setSubCategoryDescriptionForSub] = useState("");
  const [categories, setCategories] = useState([]);
  const [categoryIsGold, setCategoryIsGold] = useState(false);

  const handleSaveMainCategory = async () => {
    try {
      if (
        mainCategoryName === "" ||
        mainCategoryName === null ||
        mainCategoryName === undefined
      ) {
        myToast({ status: "warn", message: "Kategori Adı Boş Olamaz" });
        return;
      } else if (
        mainCategoryDescription === "" ||
        mainCategoryDescription === null ||
        mainCategoryDescription === undefined
      ) {
        myToast({ status: "warn", message: "Kategori Açıklama Boş Olamaz" });
        return;
      } else {
        const API = API_URL + "/category/saveCategory";
        const response = await fetch(API, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryName: mainCategoryName,
            categoryDescription: mainCategoryDescription,
            currency: categoryIsGold,
          }),
        });
        const data = await response.json();
        if (data) {
          myToast({ status: "success", message: "Kategori Eklendi" });
          window.location.reload();
        } else {
          myToast({ status: "error", message: "Kategori Eklenemedi" });
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleSaveSubCategory = async () => {
    try {
      if (
        selectedCategoryForSub === "" ||
        selectedCategoryForSub === null ||
        selectedCategoryForSub === undefined
      ) {
        myToast({ status: "warn", message: "Ana Kategori Seçiniz" });
        return;
      } else if (
        subCategoryNameForSub === "" ||
        subCategoryNameForSub === null ||
        subCategoryNameForSub === undefined
      ) {
        myToast({ status: "warn", message: "Alt Kategori Adı Boş Olamaz" });
        return;
      } else if (
        subCategoryDescriptionForSub === null ||
        subCategoryDescriptionForSub === "" ||
        subCategoryDescriptionForSub === undefined
      ) {
        myToast({
          status: "warn",
          message: "Alt Kategori Açıklama Boş Olamaz",
        });
        return;
      } else {
        const API = API_URL + "/subCategory/saveSubCategory";
        const response = await fetch(API, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            subcategoryName: subCategoryNameForSub,
            subcategoryCategoryFk: selectedCategoryForSub.categoryId,
            subcategoryDescription: subCategoryDescriptionForSub,
          }),
        });
        const data = await response.json();
        if (data) {
          myToast({ status: "success", message: "Alt Kategori Eklendi" });
          window.location.reload();
        } else {
          myToast({ status: "error", message: "Alt Kategori Eklenemedi" });
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAllCategory = async () => {
    try {
      const API = API_URL + "/fullCategory/getAllFullCategory";
      const response = await fetch(API);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    getAllCategory();
  }, []);

  return (
    <>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Yeni Kategori Ekle
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
        >
          <Tab 
            label="Ana Kategori" 
            sx={{ 
              fontWeight: 500,
              fontSize: '1rem',
              textTransform: 'none'
            }} 
          />
          <Tab 
            label="Alt Kategori" 
            sx={{ 
              fontWeight: 500,
              fontSize: '1rem',
              textTransform: 'none'
            }} 
          />
        </Tabs>

        {tabValue === 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              fullWidth
              label="Ana Kategori Adı"
              value={mainCategoryName}
              onChange={(e) => setMainCategoryName(e.target.value)}
            />
            <TextField
              fullWidth
              label="Ana Kategori Açıklama"
              value={mainCategoryDescription}
              onChange={(e) => setMainCategoryDescription(e.target.value)}
              multiline
              rows={3}
            />
            <FormControl>
              <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                Kategori Türü
              </Typography>
              <RadioGroup
                row
                value={categoryIsGold}
                onChange={(e) => setCategoryIsGold(e.target.value === 'true')}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio color="primary" />}
                  label="Altın Kategorisi"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio color="primary" />}
                  label="Döviz Kategorisi"
                />
              </RadioGroup>
            </FormControl>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <TextField
              select
              fullWidth
              label="Ana Kategori Seçin"
              value={selectedCategoryForSub || ''}
              onChange={(e) => setSelectedCategoryForSub(e.target.value)}
            >
              {categories.map((item) => (
                <MenuItem key={item.categoryId} value={item}>
                  {item.categoryName}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              fullWidth
              label="Alt Kategori Adı"
              value={subCategoryNameForSub}
              onChange={(e) => setSubCategoryNameForSub(e.target.value)}
            />
            <TextField
              fullWidth
              label="Alt Kategori Açıklama"
              value={subCategoryDescriptionForSub}
              onChange={(e) => setSubCategoryDescriptionForSub(e.target.value)}
              multiline
              rows={3}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 0 }}>
        <Button onClick={onClose} color="inherit">
          İptal
        </Button>
        <Button
          variant="contained"
          onClick={tabValue === 0 ? handleSaveMainCategory : handleSaveSubCategory}
        >
          Kaydet
        </Button>
      </DialogActions>
    </>
  );
};

export default CategoryAdd;
